import { useEffect, useState } from "react";
import { usePixiBillingClient } from "../../billing/usePixiBillingClient";
import { ShippingRate } from "./shippingRates";

export interface UseShippingRates {
  rates: ShippingRate[];
  loading: boolean;
  error: boolean;
}

/**
 * Loads the PIXI hardware shipping rates once on mount via the billing SDK
 * (`getHardwareShippingRates`). The selected-country amount is derived from
 * `rates` via `shippingAmountFor`.
 */
export const useShippingRates = (): UseShippingRates => {
  const billing = usePixiBillingClient();
  const [rates, setRates] = useState<ShippingRate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(false);
      try {
        const result = await billing.listShippingRates();
        if (!cancelled) setRates(result);
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [billing]);

  return { rates, loading, error };
};
